import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";

/** Slim mobile-only bottom bar keeping signup one thumb-tap away.
 *  Mounted inside NavWrapper so it inherits the marketing-page gating. */
export const StickyMobileCta = () => {
  const [visible, setVisible] = React.useState(false);
  const [dismissed, setDismissed] = React.useState(
    () => sessionStorage.getItem("cta_bar_dismissed") === "1",
  );
  const { pathname } = useLocation();
  const loggedIn = !!localStorage.getItem("cryptpe_token");

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (loggedIn || dismissed) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(env(safe-area-inset-bottom,0px)+10px)] transition-[transform,opacity] duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-2 rounded-full border border-white/15 bg-black/85 backdrop-blur-xl p-1.5 pl-4 shadow-[0_-10px_40px_rgba(0,0,0,0.6)]">
        <span className="mono text-[10px] uppercase tracking-[0.15em] text-zinc-400 flex-1 min-w-0 truncate">
          free · 0% fees · 60s
        </span>
        <Link
          to="/signup"
          data-testid="sticky-cta-claim-link"
          className="shrink-0 inline-flex items-center gap-1.5 bg-white text-black text-[12.5px] font-bold lowercase px-5 h-10 rounded-full active:scale-[0.98] transition-transform"
        >
          claim your page <ArrowRight size={12} />
        </Link>
        <button
          type="button"
          aria-label="dismiss"
          data-testid="sticky-cta-dismiss"
          onClick={() => { sessionStorage.setItem("cta_bar_dismissed", "1"); setDismissed(true); }}
          className="shrink-0 w-8 h-8 inline-flex items-center justify-center text-zinc-500 hover:text-white transition-colors"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default StickyMobileCta;
